<template>
    <section class="main">
        <v-page-header :title="$t('customers.title')" />

        <div class="grid-container">
            <div class="grid-x">
                <div class="cell medium-9 medium-offset-1 large-11 large-offset-0">
                    <v-action-buttons :items="getActionButtons" />

                    <div class="box">
                        <h2>{{ $t('customers.search_customer') }}</h2>
                        <form action="" method="POST" class="filter filter--search" novalidation @submit="onChangeCustomersTableFilter">
                            <div class="form-group form-group--search">
                                <input type="text" name="search" class="from-control form-control--small form-control--search" :placeholder="$t('search')" v-model="customersTableItemsFilter.search" />
                                <button role="button" type="submit" class="button" :title="$t('search')">
                                    {{ $t('search') }}
                                </button>
                            </div>
                        </form>

                        <v-letter-filter v-model="customersTableItemsFilter.letter" @onClickItem="onChangeStartLetterCustomersTableFilter" />
                    </div>

                    <div class="box">
                        <h2>{{ $t('customers.list') }}</h2>
                        <v-blocks id="blocks" :isLoading="customersTableLoading" :items="customersTableItems" :useDeactivatedSwitch="true" :showDeactivatedOnly="customersTableItemsFilter.show_deactivated_only" @onChangeShowDeactivatedOnly="onChangeShowDeactivatedOnlyCustomersTableFilter">
                            <template slot="block" slot-scope="{ row }">
                                <router-link :to="{ name : 'customers-view-customer', params : { customer : row.id } }" :title="row.company_name" class="block block--block">
                                    <div class="block--block__content">
                                        <p><strong>{{ row.company_name }}</strong></p>
                                        <template v-if="row.headquarter">
                                            <p>{{ row.headquarter.phone }}</p>
                                            <p>{{ row.headquarter.email }}</p>
                                            <p>
                                                {{ row.headquarter.address1 }} <br>
                                                {{ row.headquarter.address2 }} <br>
                                                {{ row.headquarter.zipcode }} {{ row.headquarter.city }}<br>
                                                {{ $helpers.countries[row.headquarter.country_code] }}
                                            </p>
                                        </template>
                                    </div>
                                    <div class="block--block__action">
                                        <template v-if="$store.getters.userHasPermission('customer_update')">
                                            <router-link :to="{ name : 'customers-update-customer', params : { customer : row.id } }" class="button gray-dark button--edit" :title="$t('update')">
                                                {{ $t('update') }}
                                            </router-link>
                                        </template>
                                    </div>
                                </router-link>
                            </template>
                        </v-blocks>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import PageHeader from '../partials/PageHeader';
    import ActionButtons from './../partials/Foundation/ActionButtons';

    import LetterFilter from './../partials/Foundation/LetterFilter';
    import Blocks from './../partials/Foundation/Blocks';

    export default {
        data() {
            return {
                customersTableLoading       : true,
                customersTableItems         : [],
                customersTableItemsCount    : 0,
                customersTableItemsFilter   : {
                    search                      : this.$route.query.search || '',
                    letter                      : this.$route.query.letter || '',
                    show_deactivated_only       : this.$route.query.show_deactivated_only || 0
                }
            };
        },
        components : {
            vPageHeader         : PageHeader,
            vActionButtons      : ActionButtons,
            vLetterFilter       : LetterFilter,
            vBlocks             : Blocks
        },
        computed : {
            getActionButtons : function () {
                let buttons = [];

                if (this.$store.getters.userHasPermission('customer_create')) {
                    buttons.push({
                        action  : 'create-new',
                        router  : { name : 'customers-create-customer' }
                    });
                }

                return buttons;
            }
        },
        created : function () {
            this.onUpdateCustomersTableItems(true);
        },
        methods : {
            onUpdateFilterParameters: function () {
                let query = {};

                for (let key in this.customersTableItemsFilter) {
                    if (this.customersTableItemsFilter[key]) {
                        query[key] = this.customersTableItemsFilter[key];
                    }
                }

                this.$router.push({query : query});
            },
            onChangeCustomersTableFilter : function (event) {
                event.preventDefault();

                this.onUpdateCustomersTableItems();
            },
            onChangeStartLetterCustomersTableFilter : function (letter) {
                this.customersTableItemsFilter.letter = letter;

                this.onUpdateCustomersTableItems();
            },
            onChangeShowDeactivatedOnlyCustomersTableFilter : function (show) {
                this.customersTableItemsFilter.show_deactivated_only = show;

                this.onUpdateCustomersTableItems();
            },
            onUpdateCustomersTableItems : function (firstUpdate) {
                if (!firstUpdate) {
                    this.onUpdateFilterParameters();
                }

                let promise = this.$api.clearParams()
                    .addParam('show_deactivated_only', this.customersTableItemsFilter.show_deactivated_only)
                    .addParam('search', this.customersTableItemsFilter.search)
                    .addParam('company_start', this.customersTableItemsFilter.letter)
                    .get('customers');

                promise.then((response => {
                    this.customersTableItems        = response.data.data;
                    this.customersTableItemsCount   = response.data.meta.pagination.total;

                    this.customersTableLoading      = false;
                }).bind(this)).catch((error => {
                    this.customersTableItems        = [];
                    this.customersTableItemsCount   = 0;

                    this.customersTableLoading      = false;
                }).bind(this));

                this.customersTableLoading = true;
            }
        }
    }
</script>